export const KAPTIVO_POPOUT = 'KAPTIVO_POPOUT'; // DO NOT CHANGE (also hardcoded in desktop app)
export const WEBAPP_OPEN_WHITEBOARD_POPOUT = 'WEBAPP_OPEN_WHITEBOARD_POPOUT';
export const WEBAPP_CLOSE_WHITEBOARD_POPOUT = 'WEBAPP_CLOSE_WHITEBOARD_POPOUT';
export const FETCH_ERROR_TYPES = {
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  SERVER: 'SERVER'
};
